export default __webpack_public_path__ + "static/media/ecosystem-marketplace-access.f487e262.png";